import React from 'react';

const ThankYouPage: React.FC = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>Thank You!</h1>
    <p>Your message has been sent successfully. We'll be in touch soon.</p>
  </div>
);

export default ThankYouPage;